var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.user)?_c('router-view'):(!_vm.$store.user && !_vm.$store.userLoading)?_c('Auth'):(_vm.$store.userLoading)?_c('div',{staticClass:"flex flex-center"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }